import getUsers from '../api/users/getUsers';
import ServiceUser from '../types/ServiceUser';
import { serviceState } from './state';
import { logException } from './log';

export function getUser(userId: string): ServiceUser | null {
  return serviceState.userById[userId] || null;
}

export function getUserByContactCenterUserId(
  contactCenterUserId: string,
): ServiceUser | null {
  return serviceState.userByContactCenterUserId[contactCenterUserId] || null;
}

async function requireUser(userId: string): Promise<ServiceUser> {
  let user = getUserByContactCenterUserId(userId);
  if (!user) {
    // if no user found, refresh the users
    try {
      serviceState.users = await getUsers(serviceState.id ?? '');
    } catch (err) {
      logException(err, 'Failed to refresh users');
    }
    user = getUserByContactCenterUserId(userId);
  }
  if (!user) {
    console.error(
      `A websocket event did not find a valid user account:: ${userId}, try refreshing your browser.`,
    );
    throw new Error();
  }
  return user;
}

export default requireUser;
